module.exports = "<p>\r\n  labour-punch-editing works!\r\n</p>\r\n"